import React, { useCallback } from 'react';
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {Checkbox as AntCheckbox} from 'antd';

export const Checkbox = React.forwardRef((props, ref) => {
    const { children, className } = props;

    const whenReadOnly = useCallback(() => {
        const readOnlyProps = {
            ...props,
            onChange: () => {},
            onClick: () => {},
            className: `ant-custom-readonly ${className}`,
        };

        return <AntCheckbox {...readOnlyProps} />;
    }, [props, className]);

    const notReadOnly = useCallback(() => (
        <AntCheckbox {...props} ref={ref}>
            {children}
        </AntCheckbox>
    ), [children, props, ref]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});

Checkbox.Group = React.forwardRef((props, ref) => {
    const { children, className } = props;

    const whenReadOnly = useCallback(() => {
        const readOnlyProps = {
            ...props,
            onChange: () => {},
            onClick: () => {},
            className: `ant-custom-readonly ${className}`,
        };

        return <AntCheckbox.Group {...readOnlyProps} />;
    }, [props, className]);

    const notReadOnly = useCallback(() => (
        <AntCheckbox.Group {...props} ref={ref}>
            {children}
        </AntCheckbox.Group>
    ), [children, props, ref]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});
